
/**
 *  分页点击项处理方法
 * @param
 *      strPaginationPath : 分页器路径（如：".product-content div.pagination"）
 *      pageId : 当前点击项索引id
 *      fn：   回调
 * @returns 需要加载的数据页码
 */
function onClickedPageItem(strPaginationPath, pageId, fn) {
  let nCurPageIndex = parseInt($(strPaginationPath + ' ul li.active').attr('id'));
  if (pageId === 'first') {
    nCurPageIndex = 1;
  } else if (pageId === 'pre') {
    if (nCurPageIndex > 1) {
      nCurPageIndex -= 1;
    }
  } else if (pageId === 'less') {
    if (nCurPageIndex > 5) {
      nCurPageIndex -= 5;
    } else {
      nCurPageIndex = 1;
    }
  } else if (pageId === 'more') {
    nCurPageIndex += 4;
  } else if (pageId === 'next') {
    const pageCount = parseInt($(strPaginationPath + ' ul li#lastest').attr('maxId'));
    if (pageCount > nCurPageIndex) {
      nCurPageIndex += 1;
    }
  } else if (pageId === 'lastest') {
    nCurPageIndex = parseInt($(strPaginationPath + ' ul li#lastest').attr('maxId'));
  } else {
    nCurPageIndex = parseInt(pageId);
  }
  fn && fn(nCurPageIndex);
  return nCurPageIndex;
}
/**
 *  分页数据请求结果处理回填分页器
 * @param
 *      pageInfo: {
 *       nPageIndex:   当前页索引
 *       nPageSize:  每页数据数量
 *       nPageCount: 总页数
 *       nTotalCount: 总数据数量
 *      }
 *  domElement: 如：$('.area-detail-content div div.pagination')
 */
function appendPageToDOM(pageInfo, domElement, bindItemFn, clickedEvent) {
  const path = domElement.selector;
  domElement.html('');
  if (!pageInfo) {
    return;
  }
  domElement.append('<ul></ul>');
  domElement = domElement.children().first();
  let align = 1;
  if (pageInfo.nPageCount > 10) {
    if (pageInfo.nPageIndex > pageInfo.nPageCount - 4) {
      align = 3;
    } else if (pageInfo.nPageIndex >= 5) {
      align = 2;
    }
  }
  if (align === 1) {
    if (pageInfo.nPageCount > 10) {
      domElement.append('<li id="first"><<</li>');
      domElement.append('<li id="pre"><</li>');
      let itemStr;
      for (let i = 1; i <= 5; i++) {
        itemStr = '<li id="' + i + '"' + ((i === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + i + '</li>';
        domElement.append(itemStr);
      }
      domElement.append('<li id="more">...</li>');
      domElement.append('<li id="' + pageInfo.nPageCount + '">' + pageInfo.nPageCount + '</li>');
      domElement.append('<li id="next">></li>');
      domElement.append('<li id="lastest" maxId="' + pageInfo.nPageCount + '">>></li>');
    } else {
      for (let i = 1; i <= pageInfo.nPageCount; i++) {
        domElement.append('<li' + ((i === pageInfo.nPageIndex) ? ' class="active"' : '') + ' id=' + i + '">' + i + '</li>');
      }
    }
  } else {
    domElement.append('<li id="first"><<</li>');
    domElement.append('<li id="pre"><</li>');
    domElement.append('<li id="1">1</li>');
    domElement.append('<li id="less">...</li>');
    if (align === 2) {
      let itemStr;
      let indexTmp;
      for (let i = 0; i < 5; i++) {
        indexTmp = pageInfo.nPageIndex - 2 + i;
        itemStr = '<li id="' + indexTmp + '"' + ((indexTmp === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + indexTmp + '</li>';
        domElement.append(itemStr);
      }
      domElement.append('<li id="more">...</li>');
      domElement.append('<li id="' + pageInfo.nPageCount + '">' + pageInfo.nPageCount + '</li>');
    } else {
      let itemStr;
      let indexTmp;
      for (let i = 0; i < 5; i++) {
        indexTmp = pageInfo.nPageCount - 4 + i;
        itemStr = '<li id="' + indexTmp + '"' + ((indexTmp === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + indexTmp + '</li>';
        domElement.append(itemStr);
      }
    }
    domElement.append('<li id="next">></li>');
    domElement.append('<li id="lastest" maxId="' + pageInfo.nPageCount + '">>></li>');
  }
  bindItemClickEvent(path, bindItemFn, clickedEvent);
}

/**
 * 
 * @param {分页器路径} path 如：'.area-detail-content div div.pagination'
 * @param {*} bindItemFn
 * @param {页项按钮点击处理事件，clickedEvent(pageIndex, callback)} clickedEvent
 */
function bindItemClickEvent(path, bindItemFn, clickedEvent) {
  if (bindItemFn) {
    bindItemFn();
  } else if (path && clickedEvent) {
    $(path + ' ul li').each(function() {
      const id = $(this).attr('id');
      $(this).click(function() {
        const nPageIndex = onClickedPageItem('.procurement .procurement-warpper .pagination', id);
        clickedEvent(nPageIndex, function(pageInfo) {
          appendPageToDOM(pageInfo, $(path), null, clickedEvent);
        });
      });
    });
  }
}

module.exports = {
  onClickedPageItem,
  appendPageToDOM,
  bindItemClickEvent
};
